import React, { useEffect, useState } from 'react';
import { api, useServer } from '../contexts/ServerContext';

function formatDate(ts) {
  if (!ts) return '-';
  const d = new Date(ts * 1000);
  return d.toLocaleString('ru-RU');
}

function prettifyJson(str) {
  if (!str) return '-';
  try {
    return JSON.stringify(JSON.parse(str), null, 2);
  } catch {
    return str;
  }
}

function IpStats() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(30);
  const [openPayload, setOpenPayload] = useState({});
  const { server } = useServer();

  useEffect(() => {
    setLoading(true);
    api.get(`/api/admin/ip-stats?server=${server}&page=${page}&limit=${limit}`)
      .then(res => {
        setLogs(res.data.logs || []);
        setTotalCount(res.data.totalCount || 0);
        setLimit(res.data.limit || 30);
      })
      .catch(() => {
        setLogs([]);
        setTotalCount(0);
      })
      .finally(() => setLoading(false));
  }, [server, page, limit]);

  const totalPages = Math.max(1, Math.ceil(totalCount / limit));

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-gmod-white ml-4">IP-Статистика</h1>
        <p className="text-gmod-white opacity-60 mt-2 ml-4">Логи всех подключений к панели (последние {totalCount})</p>
      </div>
      <div className="bg-gmod-dark rounded-lg border border-gmod-lighterer p-6 overflow-x-auto">
        {loading ? (
          <div className="flex items-center justify-center h-32">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-theme-primary"></div>
          </div>
        ) : logs.length === 0 ? (
          <p className="text-gmod-white opacity-60 text-center py-8">Нет логов</p>
        ) : (
          <>
            <table className="min-w-full text-sm text-gmod-white opacity-80">
              <thead>
                <tr>
                  <th className="px-4 py-2 text-left">Время</th>
                  <th className="px-4 py-2 text-left">IP</th>
                  <th className="px-4 py-2 text-left">Путь</th>
                  <th className="px-4 py-2 text-left">Метод</th>
                  <th className="px-4 py-2 text-left">UserID</th>
                  <th className="px-4 py-2 text-left">User-Agent</th>
                  <th className="px-4 py-2 text-left">Payload</th>
                </tr>
              </thead>
              <tbody>
                {logs.map(log => (
                  <React.Fragment key={log.id}>
                    <tr className="border-b border-gmod-lighterer hover:bg-theme-primary/40 transition">
                      <td className="px-4 py-2">{formatDate(log.created_at)}</td>
                      <td className="px-4 py-2 font-mono">{log.ip}</td>
                      <td className="px-4 py-2">{log.path}</td>
                      <td className="px-4 py-2">{log.method}</td>
                      <td className="px-4 py-2 font-mono">{log.user_id || '-'}</td>
                      <td className="px-4 py-2 truncate max-w-xs" title={log.user_agent}>{log.user_agent}</td>
                      <td className="px-4 py-2">
                        {log.payload && log.payload !== '{}' ? (
                          <button
                            className="px-2 py-1 bg-gmod-lighter text-gmod-white rounded hover:bg-theme-primary border border-gmod-lighterer text-xs"
                            onClick={() => setOpenPayload(prev => ({ ...prev, [log.id]: !prev[log.id] }))}
                          >
                            {openPayload[log.id] ? 'Скрыть' : 'Показать'}
                          </button>
                        ) : (
                          <span className="text-gmod-white opacity-40 text-xs">-</span>
                        )}
                      </td>
                    </tr>
                    {openPayload[log.id] && (
                      <tr>
                        <td colSpan={7} className="bg-gmod-lighter/10 px-4 py-2">
                          <pre className="whitespace-pre-wrap break-all text-xs text-gmod-white bg-gmod-dark rounded p-2 border border-gmod-lighterer overflow-x-auto">
                            {prettifyJson(log.payload)}
                          </pre>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
            <div className="flex justify-center items-center gap-2 mt-4">
              <button
                onClick={() => setPage(p => Math.max(1, p - 1))}
                disabled={page === 1}
                className="px-3 py-1 bg-gmod-lighter text-gmod-white rounded disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gmod-lighterer text-sm"
              >Назад</button>
              <span className="text-gmod-white text-sm">Страница {page} из {totalPages}</span>
              <button
                onClick={() => setPage(p => Math.min(totalPages, p + 1))}
                disabled={page === totalPages}
                className="px-3 py-1 bg-gmod-lighter text-gmod-white rounded disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gmod-lighterer text-sm"
              >Вперёд</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default IpStats; 